// System directives

'use client';

// System dependencies

// Application dependencies

import FormError from '@/components/form/formError/FormError';
import { getFormErrorSelector } from '@/redux/formError/formError.slices';
import { useAppSelector } from '@/redux/store.hooks';

const FormErrorProvider = () => {
  // Application state

  const { buttonCaption, buttonRoute, code, isActive, message, showClose } = useAppSelector(getFormErrorSelector);

  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return <FormError buttonCaption={buttonCaption} buttonRoute={buttonRoute} code={code} isActive={isActive} message={message} showClose={showClose} />;
};

export default FormErrorProvider;
